/**
 * Created by stonewang on 2017/9/11.
 */
import {config, request} from 'Utils';
//新闻列表
export function list(param) {
  /*
   {
   "effectiveEndDate": "2017-09-11T04:42:14.660Z",
   "effectiveStartDate": "2017-09-11T04:42:14.660Z",
   "endDate": "2017-09-11T04:42:14.660Z",
   "isPublish": 0,
   "publishDate": "2017-09-11T04:42:14.660Z",
   "s": 0,
   "p": 0,
   "startDate": "2017-09-11T04:42:14.661Z",
   "title": "string",
   "type": "string",
   }
  * */
  return request(`${config.server}/api/v1/dms/notice/noticeList`, {
    method: 'post',
    body: param,
  });
}
//新增通知公告
export function add(param) {
  /*
   {
   content (string, optional): 正文 ,
   effectiveEndDate (string, optional): 有效时间止 ,
   effectiveStartDate (string, optional): 有效时间起 ,
   rangeList (Array[integer], optional): 发布范围ID列表 ,
   title (string, optional): 标题 ,
   type (string, optional): 类型 ,
   }
  * */
  return request(`${config.server}/api/v1/dms/notice/addNotice`, {
    method: 'post',
    body: param,
  });
}
//新闻列表
export function detail(param) {
  return request(`${config.server}/api/v1/dms/notice/noticeDetail?id=${param}`);
}



// WEBPACK FOOTER //
// ./src/service/notice/index.js